import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

@Component({
  selector: 'app-modal-autorizacao',
  templateUrl: './modal-autorizacao.component.html',
  styleUrls: ['./modal-autorizacao.component.scss']
})
export class ModalAutorizacaoComponent {
  form: FormGroup;
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private authService: AuthService,
    public dialogRef: MatDialogRef<ModalAutorizacaoComponent>,
    public dialog: MatDialog,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  initForm() {
    const form = this.fb.group({
      TX_MAIL_FUNC: this.fb.control('', {
        validators: [Validators.required]
      }),
      TX_SENH_FUNC: this.fb.control('', {
        validators: [Validators.required, Validators.minLength(8)]
      })
    });
    return form;
  }

  postLogin() {
    this.isLoading = true;
    const { TX_MAIL_FUNC, TX_SENH_FUNC } = this.form.value;
    this.authService.loginFunc(TX_MAIL_FUNC, TX_SENH_FUNC, true).subscribe({
      next: (res: any) => {
        this.swalAlert.showAlert(
          'Sucesso!',
          'Login efetuado com sucesso.',
          'success',
          true,
          false,
          undefined,
          () => {
            this.dialogRef.close(res.Token);
          }
        );
        return;
      },
      error: (err: any) => {},
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onCancelar(): void {
    this.dialogRef.close();
  }
}
